const headers = {
  name: "Purchase received",
  navigate: {
    path: [
      {
        name: "Received",
        path: "/app/purchases/received",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
